import { render, staticRenderFns } from "./MentoriasListado.vue?vue&type=template&id=7021f803&"
import script from "./MentoriasListado.vue?vue&type=script&lang=js&"
export * from "./MentoriasListado.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports